import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { HRMTable } from '../components/hrm_table'
import HrmLoader from '../components/hrm_loader'
import NoData from '../../assets/No-Search-Result.png'
import { useNavigate } from 'react-router-dom'
import DeleteModal from '../modals/delete_model'
import { Plus } from 'lucide-react'
import { ACTIONS } from '../../constants/actions'
import { componentRoutes } from '../../constants/componentRoutes'
import { useNews } from '../../contexts/news-context'
import NewsUpdate from '../modals/EditNews'
import { adminNewsColumns } from '../../constants/data_columns/news'
import ViewModal from '../modals/View_modal'
import ViewModalNewsDiscription from '../modals/ViewModalNewsDiscription'

const NewsList = () => {
  const [newsList, setNewsList] = useState([])
  const [isDeleteFormVisible, setDeleteFormVisible] = useState(false)
  const [selectedId, setSelectedId] = useState(null)
  const [selectedRow, setSelectedRow] = useState(null)
  const [isNewsEditFormVisible, setNewsEditFormVisible] = useState(false)
  const [newsId, setNewsId] = useState(null)
  const { onLoadNews, news, newsLoader, onDeleteNews } = useNews()
  const [selectedViewId, setSelectedViewId] = useState(null)
  const [isViewFormVisible, setIsViewFormVisible] = useState(false)
  const navigate = useNavigate()
  useEffect(() => {
    const fetchData = async () => {
      await onLoadNews()
    }
    fetchData()
  }, [onLoadNews])

  useEffect(() => {
    if (news?.length > 0) {
      setNewsList(
        news.map(item => {
          return {
            id: item.id,
            title: item.title,
            description: item.description,
            image: item.image,
            logo: item.logo,
            short_description: item.short_description
          }
        })
      )
    } else {
      setNewsList([])
    }
  }, [news])

  useEffect(() => {
    if (newsId !== null) {
      navigate(componentRoutes.editNews.replace(':news_id', newsId))
    }
  }, [navigate, newsId])

  const handleView = async row => {
    if (!row) return

    try {
      setSelectedViewId(row)
      setIsViewFormVisible(true) // Open the modal
    } catch (error) {
      console.error('Failed to fetch contact details:', error)
    }
  }

  const handelAddNews = async () => {
    navigate(componentRoutes.addNews)
  }
  const handleDelete = async () => {
    if (!selectedId) return

    const response = await onDeleteNews(selectedId)
    if (response.code == 1) {
      setDeleteFormVisible(false)
      setSelectedId(null)
    }
  }

  const onSelectAction = useCallback((row, value) => {
    if (ACTIONS.DELETE === value) {
      setSelectedId(row.id)
      setDeleteFormVisible(true)
    } else if (ACTIONS.EDIT === value) {
      setSelectedRow(row)
      setNewsId(row.id)
      setNewsEditFormVisible(true)
    } else if (ACTIONS.VIEW === value) {
      setSelectedViewId(row)
      setIsViewFormVisible(true)
      handleView(row)
    }
  }, [])

  const columns = useMemo(() => {
    return adminNewsColumns({ onSelectAction })
  }, [onSelectAction])

  useEffect(() => {
    if (!setNewsEditFormVisible) {
      setSelectedRow(null)
    }
  }, [isNewsEditFormVisible])

  return (
    <>
      <div className='col-span-12 md:order-1 xl:col-span-8 2xl:col-span-6'>
        <h5 className='mb-2'>News</h5>
      </div>
      <div className='card newsListTable'>
        <div className='card-body'>
          <div className='mb-2'>
            <div className='grid grid-cols-1 gap-5 lg:grid-cols-12 items-center'>
              <div className='xl:col-span-2 xl:col-start-11'>
                <div className='ltr:lg:text-right rtl:lg:float-left'>
                  <button
                    type='button'
                    onClick={handelAddNews}
                    className='text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20'
                  >
                    <Plus className='inline-block size-4' />
                    <span className='align-middle'>Add News</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          {newsLoader ? (
            <HrmLoader />
          ) : newsList.length > 0 ? (
            <HRMTable data={newsList} columns={columns} />
          ) : (
            <img
              src={NoData}
              alt='No Data Available'
              className='w-200 h-200 mx-auto'
            />
          )}

          {isDeleteFormVisible && (
            <DeleteModal
              isVisible={isDeleteFormVisible}
              onClose={() => {
                setDeleteFormVisible(false)
                setSelectedId(null)
              }}
              onConfirm={handleDelete}
              title='Delete News'
              description='Are you sure you want to delete this News?'
            />
          )}
          <ViewModalNewsDiscription
            isVisible={isViewFormVisible}
            onClose={() => {
              setIsViewFormVisible(false)
              setSelectedViewId(null)
            }}
            onConfirm={handleView}
            title='View Contact'
            description='dsfsdff'
            data={selectedViewId?.description}
          />
          {/* {isNewsEditFormVisible && 
        <NewsUpdate 
            isNewsEditFormVisible={isNewsEditFormVisible}
            onClose={() => {
                setNewsEditFormVisible(false)
                setSelectedId(null)
            }}
            initialValues={selectedRow}
         />
    } */}
        </div>
      </div>
    </>
  )
}

export default NewsList
